module.exports = __webpack_public_path__ + "static/img/agricultural-bank.660f140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/agricultural-bank.png
// module id = 2eD4
// module chunks = 1 2